export default "__VITE_ASSET__DE2b_oGd__"